<script setup>
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAccount } from 'dashboard/composables/useAccount';
import { useAlert } from 'dashboard/composables';
import SectionLayout from './SectionLayout.vue';
import Switch from 'next/switch/Switch.vue';

const { t } = useI18n();
const isEnabled = ref(false);

const { currentAccount, updateAccount } = useAccount();

watch(
  currentAccount,
  () => {
    const { restrict_agent_conversation_visibility: isRestricted } =
      currentAccount.value?.settings || {};
    isEnabled.value = !!isRestricted;
  },
  { deep: true, immediate: true }
);

const toggleAgentConversationVisibility = async () => {
  try {
    await updateAccount({
      restrict_agent_conversation_visibility: isEnabled.value,
    });
    useAlert(
      t('GENERAL_SETTINGS.FORM.AGENT_CONVERSATION_VISIBILITY.API.SUCCESS')
    );
  } catch (error) {
    useAlert(
      t('GENERAL_SETTINGS.FORM.AGENT_CONVERSATION_VISIBILITY.API.ERROR')
    );
  }
};
</script>

<template>
  <SectionLayout
    :title="t('GENERAL_SETTINGS.FORM.AGENT_CONVERSATION_VISIBILITY.TITLE')"
    :description="t('GENERAL_SETTINGS.FORM.AGENT_CONVERSATION_VISIBILITY.NOTE')"
    with-border
  >
    <template #headerActions>
      <div class="flex justify-end">
        <Switch
          v-model="isEnabled"
          @change="toggleAgentConversationVisibility"
        />
      </div>
    </template>
  </SectionLayout>
</template>
